import React, { useState,useEffect } from 'react';
import {Link} from "react-router-dom";
import { Button,Card,Row,Col,Container} from 'react-bootstrap';
import './LeagueCard.css'

const LeagueCard = (props) => {

    const {strLeague,idLeague,strSport}=props.league;
   
    const Display=(id)=>{
     const [img,setImg]=useState([])
     useEffect(()=>{
        const url=`https://www.thesportsdb.com/api/v1/json/1/lookupleague.php?id=${id}`
        fetch(url)
        .then(res=>res.json())
        .then(data=>{
            const p=data.leagues[0].strLogo;
            setImg(p)
        })
     },[])
    
     return img;
    }
    return (
        <div className="container card-container">
            <Card className="leagueCardContainer shadow-lg p-3 mb-5 bg-white rounded d-flex align-items-center justify-content-center" style={{ width: '18rem',borderRadius:"20px"}}>
                  <Card.Img  className="cardImgBg" variant="top" src={`${Display(idLeague)}`} />
                        <Card.Body>
                        <Card.Title>{strLeague}</Card.Title>
                        <Card.Text>
                            <h3>{strSport}</h3>
                        </Card.Text>
                        <Link to={`league/${idLeague}`}>
                                <Button variant="primary">Explore -></Button>
                        </Link>
                        </Card.Body>
                </Card>
        </div>
  
                 
    );
};

export default LeagueCard;